import Card from "../Card/Card";
import useStyles from "isomorphic-style-loader/useStyles";
import s from "./Plan.css";
import React from 'react';
import Button from "@material-ui/core/Button";
import Tooltip from "@material-ui/core/Tooltip";

export default function Plan({ children, color = 'primary', tooltip, header, price, onClick, style, buttonText }) {
    useStyles(s);

    function renderButton() {
        return (
            <Button className={s.button} color={color} variant={'contained'} onClick={onClick}>{buttonText || 'Buy now'}</Button>
        );
    }

    return (
        <Card className={s.plan} style={style}>
            <h2>{header}</h2>

            <div className={s.price}>{price}</div>

            {tooltip &&
                <Tooltip
                    title={tooltip}
                    placement={'bottom'}
                >
                    {renderButton()}
                </Tooltip>
            }

            {!tooltip && renderButton()}
        </Card>
    )
}